import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { useForm, FormProvider, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { htmlValidation, useStore } from "../../helpers";
import {
    AddFamilyMembersValidations,
    AddFamilymembersFromVoterList,
    familyMemberProfileDefaultValues,
    GENDERS,
    relationShips,
    getFamilyMemberProfileDefaultValues,
} from "../../features/beneficiary-management-v2";
import { safe_get } from "../../report-visuals";
import { FormLabel, FTPInput, FTPSelect } from "../../components-new";
import { FormButtons, SideOverlay } from "../../components";
import FilePondUpload from "./sr-settings/assignees/upload-profile-pic";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { SrRenderFamily } from "./sr-render-family";
import { toJS } from "mobx";
import { useTranslation } from "react-i18next";

const familyMemberValidations = AddFamilyMembersValidations.shape({
    profile_photo: Yup.mixed().nullable().notRequired(),
});

export const FamilyMembers = observer((props: any) => {
    const params = useParams();
    const { t } = useTranslation(["service_request_home", "addServiceRequestSubject"]);
    const GENDERS_TRANSLATED = [
        { label: t("male"), value: "Male" },
        { label: t("female"), value: "Female" },
        { label: t("others"), value: "Others" },
    ];
    const projectid = params.projectid;
    const {
        beneficiaryStore,
        beneficiaryStoreV2,
        serviceRequestsStore: {
            modals,
            selectedFamilyMembers,
            update_modal_status,
            activeFamilyMember,
            setFamilyMembers,
        },
    } = useStore();
    const { familyMembers } = beneficiaryStoreV2;
    // const { activeFamilyMember } = beneficiaryStore;
    const [uploadedFile, setUploadedFile] = useState([]);
    const [files, setFiles] = useState([]);
    const { watch } = useFormContext();
    const requestLevel = watch("profile.request_level");

    const methods = useForm({
        defaultValues: getFamilyMemberProfileDefaultValues(activeFamilyMember),
        //@ts-ignore
        resolver: yupResolver(familyMemberValidations),
        mode: "onSubmit",
    });

    const saveFamilyMember = (data) => {
        const final = { ...data, profile_photo: uploadedFile };
        let updatedFamily = [...toJS(selectedFamilyMembers)];
        console.log(updatedFamily);
        const familyPersonToEditIndex = updatedFamily.findIndex((ele) => {
            return ele.id === final.voterid;
        });

        if (familyPersonToEditIndex > -1) {
            updatedFamily[familyPersonToEditIndex].profile = final;
        } else {
            updatedFamily.push({
                id: final.voterid,
                phone: final.phone,
                profile: final,
            });
        }

        setFamilyMembers(updatedFamily);
        closeFamilyMemberModal();
        setUploadedFile([]);
    };

    useEffect(() => {
        methods.reset(activeFamilyMember.profile);
        methods.setValue("phone", safe_get(activeFamilyMember, "phone", ""));
    }, [activeFamilyMember]);

    const closeFamilyMemberModal = () => {
        // beneficiaryStore.update_add_familymember_modal(false);
        update_modal_status("addFamilyMember", false);
    };
    const searchVotersHandler = () => {
        closeFamilyMemberModal();
        beneficiaryStore.update_addFamilyFromVoterListModal(true);
    };

    const addNewFamilyMemberHandler = () => {
        // beneficiaryStore.update_add_familymember_modal(true);
        // beneficiaryStore.resetActiveFamily();
        methods.reset(familyMemberProfileDefaultValues);
        update_modal_status("addFamilyMember", true);
    };
    const onError = (data) => {
        console.log(data);
    };

    return (
        <>
            <div className="mb-4 flex w-full flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
                {/*<FormLabel className="text-lg font-semibold text-gray-800">*/}
                {/*    {requestLevel === "Community"*/}
                {/*        ? t("community_members")*/}
                {/*        : t("family_members")}*/}
                {/*</FormLabel>*/}
                <FormLabel className="text-lg font-semibold text-gray-800">
                    {requestLevel === "Reference"
                        ? "Reference Members"
                        : requestLevel === "Community"
                          ? t("community_members")
                          : t("family_members")}
                </FormLabel>
                <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:gap-3">
                    <Button
                        variant="outlined"
                        color="info"
                        onClick={searchVotersHandler}
                        size="small"
                        endIcon={<AddCircleOutlineIcon />}
                        className="w-full sm:w-auto"
                    >
                        {t("add_from_voter_list")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="info"
                        onClick={addNewFamilyMemberHandler}
                        size="small"
                        endIcon={<AddCircleOutlineIcon />}
                        className="w-full sm:w-auto"
                    >
                        {t("add")}
                    </Button>
                </div>
            </div>

            <AddFamilymembersFromVoterList />
            <SrRenderFamily />

            <SideOverlay
                show={modals.addFamilyMember}
                onClose={closeFamilyMemberModal}
                size="large"
                title={t("add_family")}
            >
                <FormProvider {...methods}>
                    <form
                        onSubmit={(e) => {
                            htmlValidation(e);
                            methods.handleSubmit(saveFamilyMember, onError)(e);
                        }}
                        className="mx-auto w-full max-w-3xl space-y-4 px-3 py-4 sm:px-6"
                    >
                        <div className="flex flex-col gap-y-4">
                            <FTPInput
                                label={t("name", {
                                    ns: "addServiceRequestSubject",
                                })}
                                name="name_eng"
                            />

                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                <FTPInput
                                    label={t("phone_number", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="phone"
                                    numericOnly
                                    maxLength={10}
                                />
                                <FTPSelect
                                    label={t("gender", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="gender"
                                    options={GENDERS_TRANSLATED}
                                />
                            </div>

                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                <FTPInput
                                    label={t("voter_id", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="voterid"
                                />
                                <FTPInput
                                    label={t("aadhar_id", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="aadharid"
                                    numericOnly
                                    maxLength={12}
                                />
                            </div>

                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                <FTPInput
                                    label={t("dob", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="dob"
                                    type="date"
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                        max: new Date().toISOString().split("T")[0],
                                    }}
                                />
                                <FTPInput
                                    label={t("age", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="age"
                                    numericOnly
                                    maxLength={3}
                                />
                            </div>

                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                <FTPInput
                                    label={t("relative_name", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="relation_name_eng"
                                />
                                <FTPSelect
                                    label={t("relationship", {
                                        ns: "addServiceRequestSubject",
                                    })}
                                    name="relationship_eng"
                                    options={relationShips}
                                />
                            </div>

                            <FTPInput
                                label={t("additional_information", {
                                    ns: "addServiceRequestSubject",
                                })}
                                name="additional"
                                multiline
                                rows={3}
                                fullWidth
                            />

                            {/*<div className="w-full">*/}
                            {/*  <FilePondUpload*/}
                            {/*    path={`project-${projectid}/beneficiary/family`}*/}
                            {/*    files={files}*/}
                            {/*    onUpdate={(files) => {*/}
                            {/*      setUploadedFile(files);*/}
                            {/*      methods.setValue("profile_photo", files);*/}
                            {/*    }}*/}
                            {/*  />*/}
                            {/*</div>*/}
                        </div>

                        <div className="mt-4 flex flex-col justify-end gap-3 sm:flex-row">
                            <FormButtons onSave={() => {}} onCancel={closeFamilyMemberModal} />
                        </div>
                    </form>
                </FormProvider>
            </SideOverlay>
        </>
    );
});
